import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./LeftMenu.css";

class LeftMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: props.data.hasOwnProperty("left_menu") ? props.data.left_menu : []
		};
	}

	render() {
		const active = this.props.data.selected_third_menu_id ? this.props.data.selected_third_menu_id : "";

		let parentIndex;

		let menuItems = Array.isArray(this.state.data) ? this.state.data.slice() : [];

		menuItems = menuItems.filter(item => {
			const name = item.name ? item.name.toLowerCase() : '';
			return !name.includes('deklaracja dostę') && 
				   !name.includes('declaration of availability') &&
				   !name.includes('deklaracja dostepnosci');
		});

		return (
			<div className="LeftMenu">
				<ul className="left_menu_items">
					{menuItems.map(function (item, index) {
						if (!item.submenu) {
							parentIndex = item.id;
						}
						const isActive = active - 1 == index ? "active" : "";
						const isSubMenu = item.submenu ? "sub-item" : "main-item";
						const elementOf = `element-of-${parentIndex}`;
						const moveRight = item.move_right ? "move" : "";

						return (
							item.url ? (
								<li className={`${elementOf} ${isActive} ${isSubMenu} ${moveRight}`} key={index}>
									<a href={item.url}>
										{item.name}
									</a>
								</li>
							) : (
								<li className={`${elementOf} ${isActive} ${isSubMenu} ${moveRight}`} key={index}>
									{item.name}
								</li>
							)
						);
					})}
				</ul>
			</div>
		);
	}
}

export default withRouter(LeftMenu);


// WEBPACK FOOTER //
// ./src/Components/Elements/LeftMenu/LeftMenu.js